export default function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-shape/src/descending.js
// module id = wi75
// module chunks = 0